var _title, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCalendar = function SvgIconCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ionicon",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Calendar")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "#3c4752",
    strokeLinejoin: "round",
    strokeWidth: 32,
    x: 48,
    y: 80,
    width: 416,
    height: 384,
    rx: 48
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 232,
    r: 24,
    fill: "#3c4752"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 376,
    cy: 232,
    r: 24,
    fill: "#3c4752"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 312,
    r: 24,
    fill: "#3c4752"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 376,
    cy: 312,
    r: 24,
    fill: "#3c4752"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 312,
    r: 24,
    fill: "#3c4752"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 312,
    r: 24,
    fill: "#3c4752"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 392,
    r: 24,
    fill: "#3c4752"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 392,
    r: 24,
    fill: "#3c4752"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 392,
    r: 24,
    fill: "#3c4752"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3c4752",
    strokeLinejoin: "round",
    strokeWidth: 32,
    strokeLinecap: "round",
    d: "M128 48v32M384 48v32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3c4752",
    strokeLinejoin: "round",
    strokeWidth: 32,
    d: "M464 160H48"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-calendar.8550c5e4.svg";
export { ForwardRef as ReactComponent };